<template>
  <NavScroll>
    <template>
      <InputSearch
        v-model="form.search"
        class="filters__search"
        :class="{ 'filters__search_big': offers }"
        delay="500"
      />
      <InputRating
        v-if="!offers"
        v-model="form.rating"
        class="filters__rating"
      />
      <SelectTemplate
        v-model="form.minCount"
        class="filters__select"
        :title="$t('select.count.title')"
        :simple="true"
        :options="[
          {label: '<10', value: '<10'},
          {label: '<100', value: '<100'},
          {label: '<1000', value: '<1000'},
          {label: '<2500', value: '<2500'},
          {label: '<5000', value: '<5000'},
          {label: '>5000', value: '>5000'},
        ]"
      />
      <SelectTemplate
        v-model="form.interest"
        class="filters__select"
        :title="$t('select.titleCategoty')"
        :with-search="true"
        search-placeholder="Sport, Shoes.."
        :options="optionsInterestListWithLabel"
      />
      <SelectTemplate
        v-model="form.textile"
        class="filters__select"
        :title="$t('select.productTitle')"
        :with-search="true"
        search-placeholder="Keds, swimsuits.."
        :options="optionsTextileListWithLabel"
      />
      <SelectTemplate
        v-model="form.activity"
        class="filters__select"
        :title="$t('select.details.title')"
        search-placeholder="Tokyo, Japan.."
        :options="[{label: $t('select.details.textile'), value: 'textile',},
                   {label: $t('select.details.template'), value: 'template',},
                   {label: $t('select.details.design'), value: 'design',},
                   {label: $t('select.details.products'), value: 'products',},
        ]"
      />
      <SelectTemplate
        :value="regionsValue"
        class="filters__select"
        :title="$t('select.regions.title')"
        :with-search="true"
        :search-placeholder="$t('select.regions.placeholder')"
        :options="optionsLocationFactoryWithLabel"
        @input="onInputRegion"
      />

      <input
        v-if="form.search"
        type="hidden"
        :value="form.search"
        name="q_search"
      />
      <input
        type="hidden"
        :value="form.rating"
        name="q_rating"
      />
      <input
        v-if="form.minCount"
        type="hidden"
        :value="form.minCount"
        name="q_min_count"
      />
      <input
        v-if="form.interest.length"
        type="hidden"
        :value="form.interest"
        name="q_interest[]"
      />
      <input
        v-if="form.textile.length"
        type="hidden"
        :value="form.textile"
        name="q_textile[]"
      />
      <input
        v-if="form.activity.length"
        type="hidden"
        :value="form.activity"
        name="q_activity[]"
      />
      <input
        v-if="form.regions.length"
        type="hidden"
        :value="form.regions"
        name="q_region[]"
      />

      <button
        ref="btnSubmit"
        type="submit"
        style="display: none"
      />
    </template>
  </NavScroll>
</template>

<script>
    import { optionsTextileList, optionsInterestList, optionsLocationFactory } from '../../api/tags'
    import SelectTemplate from '../filters/SelectTemplate.vue'
    import InputSearch from '../filters/InputSearch.vue'
    import InputRating from '../filters/InputRating.vue'
    import NavScroll from '../../NavScroll.vue'

    export default {
        name: 'Filters',
        components: {
            NavScroll,
            InputRating,
            InputSearch,
            SelectTemplate,
        },
        props: {
            offers: {
                type: Boolean,
                default: false,
            },
            searchStart: {
                type: String,
                default: '',
            },
            minCountStart: {
                type: String,
                default: '',
            },
            interestStart: {
                type: [Array, Boolean],
                default: false,
            },
            textileStart: {
                type: [Array, Boolean],
                default: false,
            },
            activityStart: {
                type: [Array, Boolean],
                default: false,
            },
            ratingStart: {
                type: String,
                default: '0',
            },
            regionsStart: {
                type: [Boolean, Array],
                default: false,
            },
        },
        data: () => ({
            optionsTextileList: [],
            optionsInterestList: [],
            optionsLocationFactory: [],
            form: {
                search: null,
                minCount: '',
                interest: [],
                activity: [],
                textile: [],
                regions: [],
                verified: false,
                rating: 0,
            },
          regionsValue: [],
            timeout: true,
        }),

        computed: {
            optionsTextileListWithLabel() {
                return this.optionsTextileList.map(item => ({
                    label: item,
                    value: item,
                }))
            },
            optionsInterestListWithLabel() {
                try {
                    return this.optionsInterestList.map(item => ({
                        label: item,
                        value: item,
                    }))
                } catch (e) {
                    return []
                }
            },
            optionsLocationFactoryWithLabel() {
                try {
                    return this.optionsLocationFactory.map(item => ({
                        label: item.name,
                        value: item.value,
                    }))
                } catch (e) {
                    return []
                }
            },
        },

        watch: {
            form: {
                handler() {
                    if (this.timeout) return
                    setTimeout(() => {
                        this.$refs.btnSubmit.click()
                    }, 0)
                },
                deep: true,
            },
        },
        async mounted() {
            this.init();
            [this.optionsTextileList, this.optionsInterestList, this.optionsLocationFactory] = await Promise
                .all([optionsTextileList(), optionsInterestList(), optionsLocationFactory()])
            setTimeout(() => {
                this.timeout = false
            }, 100)
        },
        methods: {
            init() {
                if (this.ratingStart) {
                    this.form.rating = +this.ratingStart
                }
                if (this.searchStart) {
                    this.form.search = this.searchStart
                }
                if (this.minCountStart) {
                    this.form.minCount = this.minCountStart
                }
                if (this.interestStart) {
                    this.form.interest = this.interestStart[0].split(',')
                }
                if (this.textileStart) {
                    this.form.textile = this.textileStart[0].split(',')
                }
                if (this.activityStart) {
                    this.form.activity = this.activityStart
                }
                if (this.regionsStart) {
                  this.regionsValue = this.regionsStart[0].split(':')
                  this.form.regions = this.regionsStart
                }
            },
          onInputRegion(value) {
              if (Array.isArray(value)) {
                this.form.regions = value.join(':')
              }
              this.regionsValue = value
          },
        },
    }
</script>

<style scoped>

</style>
